import React from "react";

// V2C20: presentation-only handoff from a provisional private PDF preview.
// It grants no access, creates no snapshot, and never approves/locks/publishes.
// The existing Final Print Approval panel re-verifies owner/source/artifact on
// the server and requires an explicit exact-PDF acknowledgment separately.
const validId = value => /^[a-f0-9]{24}$/i.test(String(value ?? "").trim());

export default function NovelPrivatePreviewFinalHandoffV2C20({
  storyId = "", isOwner = false, privatePreviewPresent = false,
  finalPrintPilotEnabled = false, previewBusy = false, isFR = false,
  onOpenFinalApproval,
}) {
  if (isOwner !== true || privatePreviewPresent !== true || !validId(storyId)) return null;

  const canOpen = finalPrintPilotEnabled === true && previewBusy !== true &&
    typeof onOpenFinalApproval === "function";
  const label = (en, fr) => isFR ? fr : en;

  return (
    <aside role="note" data-novel-final-print-handoff-v2c20="provisional-only"
      data-novel-final-print-authority="not-established"
      style={{ padding: "12px 14px", border: "1px solid #cbd5e1",
        borderRadius: 10, background: "#f8fafc", display: "grid", gap: 9 }}>
      <span style={{ fontSize: 13, color: "#334155", lineHeight: 1.55 }}>
        {label(
          "This private PDF is only a provisional preview, not the exact final print PDF. "
          + "Opening Final Print Approval rechecks the saved archive and requires separate, "
          + "deliberate PDF review and approval. No file is approved or locked here.",
          "Ce PDF privé est un aperçu provisoire, pas le PDF final exact. "
          + "L’ouverture de l’approbation finale vérifie de nouveau l’archive enregistrée "
          + "et exige un examen et une approbation distincts du PDF. Aucun fichier n’est approuvé "
          + "ni verrouillé ici."
        )}
      </span>
      {canOpen ? (
        <div>
          <button type="button" className="ns-button ns-button-outline"
            data-novel-open-restricted-final-approval-v2c20="true"
            onClick={onOpenFinalApproval}>
            {label("Open Restricted Final Print Approval",
              "Ouvrir l’approbation finale restreinte")}
          </button>
        </div>
      ) : null}
    </aside>
  );
}
